import React from 'react';
import { useNotification } from '../../context/NotificationContext';
import './NotificationBar.scss';

const NotificationBar: React.FC = () => {
  const { currentMessage, nextMessage, isAnimating } = useNotification();

  if (!currentMessage || currentMessage.trim() === '') {
    return null;
  }

  return (
    <div className="notification-bar">
      <div className="notification-container">
        <div className="notification-content">
          <span className="notification-icon">📢</span>
          <div className="notification-text-wrapper">
            <span className={`notification-text current ${isAnimating && nextMessage ? 'slide-up' : ''}`}>
              {currentMessage}
            </span>
            {nextMessage && (
              <span className={`notification-text next ${isAnimating ? 'slide-in' : ''}`}>
                {nextMessage}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationBar;

